import React, { useCallback, useEffect, useMemo } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import qs from 'query-string';

import { useConfirmSignUpMutation, useGetRolesQuery, useResendSignUpMutation } from 'api/main';
import { CognitoErrors, roleCategories, queryStringifyOptions } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import TunnelContainer from 'containers/tunnel/common/TunnelContainer';
import { BigLoader, SuccessMessage } from 'components';
import { Box, Typography } from '@mui/material';

const ConfirmSignUp = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = qs.parse(location.search, queryStringifyOptions);
    const { email, code, fund_id: fund, role_id } = params;

    const { data: roles = [], isLoading: rolesLoader } = useGetRolesQuery();
    const [resendSignUp, { isSuccess: resendSuccessful }] = useResendSignUpMutation();
    const [confirmSignUp, { isLoading: buttonLoader, isSuccess: confirmSuccessful, error }] =
        useConfirmSignUpMutation();

    const isRoleDistributor = useMemo(() => {
        const role = roles.find(r => r.id === +role_id);
        if (role) {
            return role.category?.name === roleCategories.ADMIN_DISTRIBUTORS;
        }
        return false;
    }, [role_id, roles]);

    useEffect(() => {
        if (email && code) {
            confirmSignUp({ email, code });
        }
    }, [confirmSignUp, email, code]);

    const handleResend = useCallback(
        e => {
            e.preventDefault();
            if (!resendSuccessful) {
                resendSignUp(email);
            }
        },
        [resendSuccessful, resendSignUp, email]
    );

    useEffect(() => {
        if (confirmSuccessful) {
            navigate('/sign-in', { state: { isEmailConfirmed: true, isRoleDistributor } });
        }
    }, [confirmSuccessful, isRoleDistributor, navigate]);

    useEffect(() => {
        if (!email || !code || !fund) {
            navigate('/sign-in');
        }
    }, [code, email, fund, navigate]);

    return (
        <TunnelContainer>
            {error?.code === CognitoErrors.CODE_MISMATCH ||
            error?.name === CognitoErrors.CODE_MISMATCH ? (
                <Box padding="30px">
                    <Typography align="center" variant="h5" gutterBottom>
                        {texts.LIEN_EXPIRE}
                    </Typography>
                    <Typography align="center" gutterBottom>
                        {texts.LIEN_POUR_LA_CONFIRMATION_A_EXPIRE}
                    </Typography>
                    <Typography align="center" display="block" gutterBottom>
                        <Link to="/" onClick={handleResend}>
                            {texts.CLICK_HERE}
                        </Link>{' '}
                        {texts.POUR_RECEVOIR_UN_NOUVEAU_EMAIL}
                    </Typography>
                    {resendSuccessful && (
                        <SuccessMessage message={texts.UN_NOUVEAU_MESSAGE_VOUS_SERA_ENVOYE} />
                    )}
                </Box>
            ) : (
                (buttonLoader || rolesLoader) && <BigLoader />
            )}
        </TunnelContainer>
    );
};

export default ConfirmSignUp;
